var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-block",class:{ 'black' : _vm.black }},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24033fdb","hasScoped":true,"transformToRequire":{"video":"src","source":["src","srcset"],"vector":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/card-block/card.block.vue
// module id = Giwe
// module chunks = 1